var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accueil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-11",
    transform: "translate(-339.000000, -826.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(339.000000, 826.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#01205C",
    cx: 7.5,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(4.200000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 4.200000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-2",
    points: "0.0947368421 0 7.10526316 0 7.10526316 4.0173913 0.0947368421 4.0173913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22308398,0 C5.21190715,0.0131735199 5.20109903,0.0266797044 5.18962261,0.0396314479 C4.76868223,0.514454783 4.20414831,0.77595137 3.6,0.77595137 C2.99582864,0.77595137 2.43129473,0.514454783 2.01035434,0.0396314479 C1.99887792,0.0266797044 1.98809285,0.0131735199 1.97689297,0 C0.869303096,0.487043216 0.0947368421,1.56449964 0.0947368421,2.80766742 L0.0947368421,3.60863517 C0.0947368421,3.83438139 0.284904368,4.0173913 0.519479653,4.0173913 L6.6804973,4.0173913 C6.91509563,4.0173913 7.10526316,3.83438139 7.10526316,3.60863517 L7.10526316,2.80766742 C7.10526316,1.56449964 6.33067386,0.487043216 5.22308398,0",
    id: "Fill-1",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.82418319,3.63898459 C5.17822954,3.25549473 5.4,2.70806501 5.4,2.1 C5.4,0.940213881 4.59410221,0 3.60001117,0 C2.60587545,0 1.8,0.940213881 1.8,2.1 C1.8,2.70806501 2.02177046,3.25549473 2.37579447,3.63898459 C2.69702318,3.98694267 3.12709299,4.2 3.60001117,4.2 C4.07290701,4.2 4.50297682,3.98694267 4.82418319,3.63898459 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfil);
export default __webpack_public_path__ + "static/media/profil.f28b3e1a24f46db887e77c34b144010d.svg";
export { ForwardRef as ReactComponent };